import React from 'react';
import PropTypes from 'prop-types';
import './CartPage.css';
import Item from './Item';

function CartPage({cart, onAddOne, onRemoveOne}) {

    return(
        <ul className="CartPage-cart">
            {cart.length > 0 ? cart.map(item => 
                <li key={item.id} className="CartPage-item">
                    <Item item={item}>
                        <div className="CartItem-controls">
                            <button className="CartItem-removeOne" onClick={() => onRemoveOne(item)}>
                                &ndash;
                            </button>
                            <span className="CartItem-count">
                                {item.count}
                            </span>
                            <button className="CartItem-addOne" onClick={() => onAddOne(item)}>
                                +
                            </button>
                        </div>
                    </Item>    
                </li>
            ) : <div>
                    Your cart is empty!
                </div>}
        </ul>
    );
}

CartPage.propTypes = {
    items: PropTypes.array.isRequired,
    onAddOne: PropTypes.func.isRequired,
    onRemoveOne: PropTypes.func.isRequired
}

export default CartPage;